module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_robot.ver2_0_2.png?bb19ffd4";